<script setup>

</script>

<template>
<img src="https://myflow.fra1.digitaloceanspaces.com/ai-agent/grouped-v2.webp" alt="Group photo of your AI assistans" />
</template>

<style scoped>

</style>
